﻿import Image from "../image";
import ActivePage from "../activePage";

export default class PatActionDueInvPage extends ActivePage {

    constructor() {
        super();
        this.appInfo = [];
        this.image = new Image();
        this.editableGrids = [];
        this.tabsLoaded = [];
    }

    init(addMode, parentId, pageId) {
        this.editableGrids = [
            {
                name: `actionsGrid_${pageId}`, isDirty: false, filter: { parentId: parentId }, afterSubmit: (e) => { this.updateRecordStamps(); pageHelper.handleEmailWorkflow(e);},
            }
        ];

        this.appInfo = [{ CaseNumber: "" }];
        this.tabsLoaded = [];
        this.tabChangeSetListener();

        $(document).ready(()=> {
            if (addMode) {
                const caseNumber = this.getKendoComboBox("CaseNumber");
                const actionType = this.getKendoComboBox("ActionType");

                //country.enable(caseNumber.value());
                actionType.enable(caseNumber.value());

                if (caseNumber.value()) {
                    this.getKendoComboBox("ActionType").input.attr("autofocus", "autofocus");
                }
                else {
                    caseNumber.input.attr("autofocus", "autofocus");
                }

            }
        });
    }

    actionTypeLinkData=()=> {
        const actionType = this.getKendoComboBox("ActionType");
        return { actionType: actionType.value() };
    }

    countryLinkData = () => {
        const caseNumber = this.getKendoComboBox("CaseNumber");
        return { caseNumber: caseNumber.value() };
    }

    tabChangeSetListener() {
        $('#actionDueTab a').on('click', (e)=> {
            e.preventDefault();
            const tab = e.target.id;
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
        });
    }

    afterInsert = (result) => {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            $(`#${this.mainDetailContainer}`).find("#actionDueInvDetailDueDatesTab").click();
            pageHelper.handleEmailWorkflow(result);
        });
    }

    showDetails(result) {
        let id = result;
        if (isNaN(result))
            id = result.id;
        
        pageHelper.showDetails(this, id, () => {
            pageHelper.handleEmailWorkflow(result);
        });
    }

    deleteDueDate = (e, grid, deleteActionDuePrompt) => {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        if (grid.dataSource.total() === 1) {
            grid.options.editable.confirmDelete = deleteActionDuePrompt;
            pageHelper.deleteGridRow(e, dataItem, (result) => {
                
                if (result.emailWorkflows) {
                    const promise = pageHelper.handleEmailWorkflow(result);
                    promise.then(() => {
                        window.cpiBreadCrumbs.showPreviousNode();
                    });
                }
                else {
                    if (result.success)
                        cpiAlert.warning(result.success);

                    window.cpiBreadCrumbs.showPreviousNode();
                }
                    
            });
        }
        else {
            //this.deleteGridRow(e, grid);
            pageHelper.deleteGridRow(e, dataItem, (result) => {
                this.updateRecordStamps();
                pageHelper.handleEmailWorkflow(result);
            });
        }
    }

    loadTabContent(tab) {
        switch (tab) {
            case "actionDueInvDetailDueDatesTab":
                $(document).ready(()=> {
                    const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    if (parseInt(grid.options.dataSource.pageSize) > 0)
                        grid.dataSource.pageSize(grid.options.dataSource.pageSize);
                    else
                        grid.dataSource.read();
                });
                break;

            //case "actionDueDetailDocumentsTab":
            //    $(document).ready(()=> {
            //        this.image.initializeImage(this);
            //    });
            //    break;

            //case "actionDueDetailCorrespondenceTab":
            //    $(document).ready(()=> {
            //        const grid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
            //        grid.dataSource.read();
            //    });
            //    break;

            case "":
                break;
        }
    }

    caseNumberSearchValueMapper(options) {
        $.ajax({
            url: this.caseNumberSearchValueMapperUrl,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    caseNumberDetailValueMapper(options) {
        $.ajax({
            url: this.caseNumberDetailValueMapperUrl,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }
    
    getAppInfo(callback) {
        const caseNumber = this.getKendoComboBox("CaseNumber");

        this.cpiLoadingSpinner.show();
        $.get(caseNumber._form.data("app-info-url"), { caseNumber: caseNumber.value() })
            .done((data)=> {
                this.cpiLoadingSpinner.hide();
                this.appInfo = data;

                if (typeof callback !== "undefined" && callback !== null) {
                    callback();
                }
            })
            .fail((e)=> {
                this.cpiLoadingSpinner.hide();
                pageHelper.showErrors(e);
            });
    }
    
    showAppInfo(sender, caseNumber, country, subCase) {
        const elName = sender.element[0].name;
        const appInfo = this.appInfo.find(function (appInfo) {
            return appInfo.CaseNumber === caseNumber;
            //switch (elName) {
            //    case "SubCase":
            //        return appInfo.CaseNumber === caseNumber && appInfo.Country === country && appInfo.SubCase === subCase;
            //    case "Country":
            //        return appInfo.CaseNumber === caseNumber && appInfo.Country === country;
            //    default:
            //        return appInfo.CaseNumber === caseNumber;
            //}
        });

        if (appInfo === undefined) {
            sender.value("");
            this.clearAppInfo();
            return;
        }

        //const cboCountry = this.getKendoComboBox("Country");
        //const countryName = $(`#${cboCountry.element[0].id}_Name`);
        //const cboSubCase = this.getKendoComboBox("SubCase");
        const cboActionType = this.getKendoComboBox("ActionType");

        //cboCountry.value(appInfo["Country"]);
        //cboCountry.element.trigger("change");
        //countryName.val(appInfo["CountryName"]).trigger("change");

        //cboSubCase.value(appInfo["SubCase"]);
        //cboSubCase.element.trigger("change");

        //if (elName !== "SubCase") {
        //    if (!cboActionType.value()) {
        //        cboActionType.value("");
        //        cboActionType.element.trigger("change");
        //    }
            
        //}

        //cboCountry.enable(true);
        //cboSubCase.enable(true);
        cboActionType.enable(true);

        for (const property in appInfo) {
            let value = appInfo[property];
            const element = this.getElement(property);
            if (element.length > 0 && element.data("role") !== "combobox") {
                if (isNaN(value) && Date.parse(value))
                    value = pageHelper.cpiDateFormatToDisplay(new Date(value));

                element.val(value).trigger("change");
            }
        }
    }

    
    clearAppInfo() {
        const caseNumber = this.getKendoComboBox("CaseNumber");
        //const country = this.getKendoComboBox("Country");
        //const countryName = $(`#${country.element[0].id}_Name`);
        //const subCase = this.getKendoComboBox("SubCase");
        const actionType = this.getKendoComboBox("ActionType");

        if (caseNumber.value() === "") {
            //country.value("");
            //country.element.trigger("change");
            //countryName.val("").trigger("change");

            //subCase.value("");
            //subCase.element.trigger("change");

            //only when empty
            if (!actionType.value()) {
                actionType.value("");
                actionType.element.trigger("change");
            }

            //country.enable(false);
            //subCase.enable(false);
            actionType.enable(false);
        }
        //else if (country.value() === "") {
        //    countryName.val("").trigger("change");
        //    subCase.value("");
        //    subCase.element.trigger("change");

        //    //only when empty
        //    if (!actionType.value()) {
        //        actionType.value("");
        //        actionType.element.trigger("change");
        //    }

        //    subCase.enable(false);
        //    actionType.enable(false);
        //}

        for (const property in this.appInfo[0]) {
            const element = this.getElement(property);
            if (element.length > 0 && element.data("role") !== "combobox") {
                element.val("").trigger("change");
            }
        }
    }

    onCaseNumberChange=(e)=>  {
        const caseNumber = e.sender;
        this.cpiStatusMessage.hide();
        
        if (caseNumber.value()) {
            if (caseNumber.selectedIndex === -1) {
                //this.cpiStatusMessage.error(caseNumber.element.data("invalid"));
                pageHelper.showErrors(caseNumber.element.data("invalid"));
                this.clearAppInfo();
                caseNumber.value("");
                caseNumber.focus();
            }
            else {
                this.getAppInfo(()=> {
                    this.showAppInfo(caseNumber, caseNumber.value());

                    //const country = this.getKendoComboBox("Country");
                    //const subCase = this.getKendoComboBox("SubCase");
                    const actionType = this.getKendoComboBox("ActionType");

                    //country.dataSource.read();
                    //subCase.dataSource.read();
                    actionType.dataSource.read();
                });
            }
        }
        else {
            this.clearAppInfo();
        }
        
    }

    //onCountryChange=(e)=> {
    //    const comboBox = e.sender;
    //    const caseNumber = this.getKendoComboBox("CaseNumber").value();
    //    const country = comboBox.value();

    //    const subCase = this.getKendoComboBox("SubCase");
    //    subCase.dataSource.read();

    //    const actionType = this.getKendoComboBox("ActionType");
    //    actionType.dataSource.read();

    //    if (this.appInfo.length === 0 || this.appInfo[0].CaseNumber === "")
    //        this.getAppInfo(()=> {
    //            this.showAppInfo(comboBox, caseNumber, country);
    //        });
    //    else
    //        this.showAppInfo(comboBox, caseNumber, country);
    //}

    //onSubCaseChange=(e)=>  {
    //    const comboBox = e.sender;
    //    const caseNumber = this.getKendoComboBox("CaseNumber").value();
    //    const country = this.getKendoComboBox("Country").value();
    //    const subCase = comboBox.value();

    //    if (this.appInfo.length === 0 || this.appInfo[0].CaseNumber === "")
    //        this.getAppInfo(()=> {
    //            this.showAppInfo(comboBox, caseNumber, country, subCase);
    //        });
    //    else
    //        this.showAppInfo(comboBox, caseNumber, country, subCase);
    //}

    onActionTypeChange=(e)=>  {
        const actionType = e.sender.dataItem();
        const responsible = this.getKendoComboBox("ResponsibleID");
        const responsibleName = $(`#${responsible.element[0].id}_Name`);

        if (actionType && actionType.ResponsibleID && !responsible.value()) {
            responsible.value(actionType.ResponsibleID);
            responsible.element.trigger("change");
            responsibleName.val(actionType.ResponsibleName).trigger("change");
        } 

        if (actionType && actionType.IsOfficeAction) {           
            $('#IsOfficeAction').attr('checked', actionType.IsOfficeAction);
        }
    }

    getAppCountryListData=()=> {
        const caseNumber = this.getKendoComboBox("CaseNumber");
        return { caseNumber: caseNumber.value() };
    }

    //getAppSubCaseListData=()=> {
    //    const caseNumber = this.getKendoComboBox("CaseNumber");
    //    const country = this.getKendoComboBox("Country");
    //    return { caseNumber: caseNumber.value(), country: country.value() };
    //}

    //getActionTypeListData=()=> {
    //    const country = this.getKendoComboBox("Country");
    //    return { country: country.value() };
    //}

    onDueDateAttorneyChange = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
            const dataItem = grid.dataItem(row);

            dataItem.AttorneyID = e.dataItem["AttorneyID"];
        }
    }

    clearDueDateAttorney = (e) => {
        const row = $(`#${e.sender.element[0].id}`).closest("tr");
        const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
        const dataItem = grid.dataItem(row);

        if (dataItem.DueDateAttorneyName == null || dataItem.DueDateAttorneyName == "") {
            dataItem.AttorneyID = null;
            dataItem.DueDateAttorneyName == "";
        }
    }

    //showDueDateEmailScreen(e, grid) {
    //    const form = $("#" + this.detailContentContainer).find("form");
    //    const url = form.data("duedate-email-url");
    //    const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
    //    const ddId = dataItem.DDId;

    //    $.ajax({
    //        url: url,
    //        data: { id: ddId },
    //        success: function (result) {
    //            const popupContainer = $(".site-content .popup");
    //            popupContainer.html(result);
    //        },
    //        error: function (e) {
    //            pageHelper.showErrors(e);
    //        }
    //    });
    //}

    showInventionLink = (screen, title, isReadOnly) => {
        const container = $(`#${screen}`).find(".cpiButtonsDetail");
        const pageNav = container.find(".nav");
        pageNav.prepend(`<a class="nav-link invention-link" href="#" target="_self" title="${title}" role="button"><i class="fal fa-external-link pr-2"></i>${title}</a>`);
        container.find(".invention-link").on("click", function () {
            if (isReadOnly) {
                $(`#${screen}`).find(".case-number-link").trigger("click");
            }
            else
                $(`#CaseNumber_${screen}_cpiButtonLink`).trigger("click");
        });
    }
}